// https://vuex.vuejs.org/en/state.html
/* eslint no-param-reassign:0 */
export default {
  rows: state => state.rows,
  constants: state => state.constants,
};
